import { render, staticRenderFns } from "./Checkbox-Transfer.vue?vue&type=template&id=5c6e3a68&scoped=true&"
import script from "./Checkbox-Transfer.vue?vue&type=script&lang=js&"
export * from "./Checkbox-Transfer.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox-Transfer.vue?vue&type=style&index=0&id=5c6e3a68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e3a68",
  null
  
)

export default component.exports